
import { ManagePayments } from "../../contact/ManagePayments";

interface PaymentsSectionProps {
  contactId: string;
}

export const PaymentsSection = ({
  contactId,
}: PaymentsSectionProps) => {
  return (
    <div className="bg-white rounded-lg border border-gray-200 shadow-sm">
      <div className="p-6">
        <h2 className="text-xl font-semibold mb-4">Payments</h2>
        <ManagePayments contactId={contactId} />
      </div>
    </div>
  );
};
